import Vue from 'vue'
import Artists from '../../vue/discover/Artists.vue'

document.addEventListener('DOMContentLoaded', () => {
  let el = document.getElementById('vue-discover-artists')

  if (el) {
    const token = el.dataset.authToken
    localStorage.setItem('token', el.dataset.authToken)
    let selectedCountry = {
      id: localStorage.getItem('country_id'),
      name: localStorage.getItem('country_name'),
      location: localStorage.getItem('location_country'),
    }
    const props = {
      artTypeFilter: JSON.parse(el.dataset.artTypeFilter),
      specialityFilter: JSON.parse(el.dataset.specialityFilter),
      genreFilter: JSON.parse(el.dataset.genreFilter),
      cityNameFilter: JSON.parse(el.dataset.cityNameFilter),
      cityFilter: JSON.parse(el.dataset.cityFilter),
      eventTypeFilter: JSON.parse(el.dataset.eventTypeFilter),
      countryFilter: el.dataset.countryFilter,
      discoverFilters: JSON.parse(el.dataset.discoverFilters),
      discoverFilterIcons: JSON.parse(el.dataset.discoverFilterIcons),
      convertedPrice: el.dataset.convertedPrice,
      searchLocation: el.dataset.searchLocation,
      currencyCode: el.dataset.currencyCode,
      showBookingButton: el.dataset.showBookingButton === 'true',
      logged: el.dataset.logged === 'true',
      selectedCountry: selectedCountry
    }
    let toggleButton = document.getElementById('toggleButton');
    if(toggleButton) {
      toggleButton.addEventListener("click", function() {
        let arrowDownBlack=document.querySelector(".arrow-down-black")
        let descriptionBackground = document.querySelector(".discover-page-seo-description-background") 
        descriptionBackground.classList.toggle("active");
        arrowDownBlack.classList.toggle("transform");
      });
    }

    new Vue({
      el: el,
      render: h => h(Artists, { props }),
      components: {
        Artists
      }
    })
  }
})
